module.exports = __webpack_public_path__ + "fonts/futura-light-bt.98d2f973.ttf";